import React from 'react'
import {bool, node, string} from 'prop-types'

const Instruction = ({isVisible, caption, info, uniqueID}) => (isVisible ? (
  <div
    className='instruction'
    data-testid={uniqueID}
  >
    <div className='caption'>{caption}</div>

    {info && (
      <div className='info'>{info}</div>
    )}

  </div>
) : null)

Instruction.propTypes = {
  isVisible: bool,
  caption: node,
  info: node,
  uniqueID: string
}

export default Instruction
